import { render, staticRenderFns } from "./EmailUnsubscribe.vue?vue&type=template&id=f2efeaae&scoped=true"
import script from "./EmailUnsubscribe.vue?vue&type=script&lang=js"
export * from "./EmailUnsubscribe.vue?vue&type=script&lang=js"
import style0 from "./EmailUnsubscribe.vue?vue&type=style&index=0&id=f2efeaae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2efeaae",
  null
  
)

export default component.exports